import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';

/**
 * Auth Guard - Checks if user has an access token
 * If no token is found, redirects to login page
 */
export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const accessToken = localStorage.getItem('accessToken');
  
  if (!accessToken) {
    console.log('🔒 No access token found, redirecting to login');
    router.navigate(['/login']);
    return false;
  }
  
  return true;
};




